import React from 'react';
import V3Header from '../components/V3Header';
import V3Footer from '../components/V3Footer';
import { useLanguage } from '../LanguageContext';
import { legalPages } from '../content/legalPages';
import '../V3.css';

const V3LegalPage = ({ pageKey }) => {
  const { lang } = useLanguage();
  const page = legalPages[lang]?.[pageKey] || legalPages.en[pageKey];

  if (!page) return null;

  return (
    <div className="v3-app">
      <div className="v3-page">
        <V3Header />
        <div className="v3-hero">
          <h1>{page.title}</h1>
          <p style={{ fontSize: 13, color: '#444' }}>{page.updated}</p>
        </div>
        <section className="v3-block">
          <div className="v3-legal-content">
            {page.sections.map(({ heading, body, list }) => (
              <div key={heading} className="v3-legal-section">
                <h2 style={{ color: '#111' }}>{heading}</h2>
                {body && body.split('\n').map((line) => (
                  <p key={line} style={{ color: '#222', fontSize: 15, lineHeight: 1.7 }}>{line}</p>
                ))}
                {Array.isArray(list) && (
                  <ul className="v3-wire-list">
                    {list.map((item) => (
                      <li key={item} style={{ color: '#222', fontSize: 15, lineHeight: 1.7 }}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </section>
        <V3Footer />
      </div>
    </div>
  );
};

export default V3LegalPage;
